import color from '@/core/features/styles/color';

export type ShimmerBoxProps = {
    borderColor?: string;
    borderRadius?: string;
    borderWidth?: string;
    color?: string;
    height?: string;
    marginBottom?: string;
    marginTop?: string;
    noShrink?: boolean;
    size?: string;
    width?: string;
};

export default function ShimmerBox({
    borderColor = color('alto'),
    borderRadius = '5px',
    borderWidth,
    color: backgroundColor,
    height,
    marginBottom,
    marginTop,
    noShrink = false,
    size = '100%',
    width,
}: ShimmerBoxProps) {
    return (
        <>
            <div
                className={'shimmerBox'}
                style={{
                    backgroundColor,
                    border: borderWidth ? `${borderWidth} solid ${borderColor}` : undefined,
                    borderRadius,
                    flexShrink: noShrink ? '0' : 'unset',
                    height: height ?? size,
                    marginBottom: marginBottom,
                    marginTop: marginTop,
                    width: width ?? size,
                }}
            />
            <style jsx>{`
                @keyframes background-shimmer {
                    to {
                        background-position-x: -20%;
                    }
                }
                .shimmerBox {
                    animation: background-shimmer 1.5s linear 0.5s infinite normal none running;
                    background: linear-gradient(
                            120deg,
                            var(--color-alto-00) 30%,
                            var(--color-alto-05) 50%,
                            var(--color-alto-00) 70%
                        )
                        var(--color-athensGray);
                    background-size: 300% 100%;
                    background-position-x: 280%;
                    will-change: transform;
                }
            `}</style>
        </>
    );
}
